var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"title":"Address","width":"50","showModal":_vm.showModal},on:{"close-modal":_vm.closeModal}},[_c('div',[_c('GmapMap',{staticStyle:{"width":"100%","height":"400px"},attrs:{"center":_vm.center,"zoom":12}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }